<div class="address-box" [ngClass]="{ 'has-title': ShowTitle } " tabindex="0" (click)="showPicker()" (keydown.enter)="showPicker()" (keydown.space)="showPicker()">
    <ion-label [ngClass]="ShowTitle ? 'input-title': 'placeholder'">
        {{viewTitle}}<ion-icon *ngIf="!value" name="location-outline"></ion-icon>
    </ion-label>
    <ion-label [ngClass]="{'hide': !ShowTitle}">
        {{viewValue}}
    </ion-label>
</div>
<upp-er-address *ngIf="formGroup"
    [form]="formGroup"
    [name]="formControlName" 
    [value]="value"
    [errornfo]="errornfo"
></upp-er-address>
